import { render, staticRenderFns } from "./SimulacaoFinalizarOpcoes.vue?vue&type=template&id=87fe513c"
import script from "./SimulacaoFinalizarOpcoes.vue?vue&type=script&lang=js"
export * from "./SimulacaoFinalizarOpcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports